import { useQueryWithUserId } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { B2B_SERVICE_API } from '../b2bApiClient';
import { IQuoteRequestsItem } from '../types';

/**
 * Query key for enterprise recent customer quotes list caching.
 */
export const FETCH_ENT_RECENT_CUSTOMER_QUOTES_LIST_QUERY_KEY =
  'enterprise-quotes-requests-list-key';

/**
 * It returns the query for the mock enterprise quotes requests data.
 */
export function useEnterpriseQuoteRequestsListQuery() {
  /**
   * Cache stale time for the enterprise quote requests details to 30 seconds.
   */
  const CACHE_STALE_TIME = 30000;

  return useQueryWithUserId<IQuoteRequestsItem[], IApiError>({
    queryKey: [FETCH_ENT_RECENT_CUSTOMER_QUOTES_LIST_QUERY_KEY],
    queryFn: () => B2B_SERVICE_API.fetchEntRecentCustomerQuotesList(),
    staleTime: CACHE_STALE_TIME,
  });
}
